import { useNode } from "@craftjs/core";
import React, { useEffect } from "react";
import { TableOfContentsSettings } from "./settings";
import SVGIcons from "../../input/icons.json";
import GrigoraCSSRenderer from "./../css-render";
import SVG from "react-inlinesvg";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const TableOfContents = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    dataSrc = "cms-post",
    icon,
    customIcon,
    hasCustomIcon,
    hasListIcon,
    truncate,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-table-of-contents": true,
      [`table-of-contents-${id}`]: id,
      "has-icon": hasListIcon,
      truncate: truncate,
    },
    blockProps.className,
  );

  useEffect(() => {
    if (selected) {
      return;
    }
  }, [selected]);

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      onClick={() => selected}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__TableOfContents(
        id,
        props,
      )}`}</style>
      <ol className="toc-list">
        {/* for active list always add .list-active to <li> and .active to <a> of <li> */}
        <li className="toc-list-item list-active">
          {hasListIcon ? (
            hasCustomIcon && customIcon !== "" ? (
              <SVG title={icon} src={customIcon} />
            ) : (
              <>
                {icon && SVGIcons[icon] && (
                  <SVG title={icon} src={SVGIcons[icon]} />
                )}
              </>
            )
          ) : (
            <></>
          )}
          <a
            href="#"
            className="toc-list-anchor active"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Heading 1
          </a>
        </li>
        <li className="toc-list-item">
          {hasListIcon ? (
            hasCustomIcon && customIcon !== "" ? (
              <SVG title={icon} src={customIcon} />
            ) : (
              <>
                {icon && SVGIcons[icon] && (
                  <SVG title={icon} src={SVGIcons[icon]} />
                )}
              </>
            )
          ) : (
            <></>
          )}
          <a
            href="#"
            className="toc-list-anchor"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Heading 2
          </a>
        </li>
        <li className="toc-list-item">
          {hasListIcon ? (
            hasCustomIcon && customIcon !== "" ? (
              <SVG title={icon} src={customIcon} />
            ) : (
              <>
                {icon && SVGIcons[icon] && (
                  <SVG title={icon} src={SVGIcons[icon]} />
                )}
              </>
            )
          ) : (
            <></>
          )}
          <a
            href="#"
            className="toc-list-anchor"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Heading 3
          </a>
        </li>
        <li className="toc-list-item">
          {hasListIcon ? (
            hasCustomIcon && customIcon !== "" ? (
              <SVG title={icon} src={customIcon} />
            ) : (
              <>
                {icon && SVGIcons[icon] && (
                  <SVG title={icon} src={SVGIcons[icon]} />
                )}
              </>
            )
          ) : (
            <></>
          )}
          <a
            href="#"
            className="toc-list-anchor"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Heading 4
          </a>
        </li>
      </ol>
    </div>
  );
};

// To Avoid Mangling in Production
TableOfContents.displayName = "TableOfContents";

TableOfContents.craft = {
  name: "Table Of Contents",
  props: {},
  related: {
    settings: TableOfContentsSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "miscellaneous",
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "TableOfContents",
    slug: "grigora/table-of-contents",
  },
};
